import React, { FC, useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EmptyState } from '../empty_state/EmptyState';
import PaginatedReduxTableWithHeader from '../common/PaginatedReduxTableWithHeader';
import { Button } from 'antd';
import { nullSafeGetOrElse, stopDefaultEvents } from '../../utils/DataAccessUtils';
import TaxRateModal from '../stock_locations_detail_details_page/TaxRateModal';
import { getCurrentTaxRateFromStockLocation } from '../stock_locations_detail_details_page/burden_rate_utils';
import { locationsRestCrudThunksForSupplier } from '../../thunks/locations_thunks';
import { LOCATIONS_CRUD_ACTION_CREATORS } from '../../actions/locations_actions';

const AccountingTaxRatePage: FC<any> = ({
	locations,
	updateFilters,
	clearAndUpdateFilters,
}): React.ReactElement => {
	const [currentEditingRecord, setCurrentEditingRecord] = useState(null);
	const [editRateModalVisible, setEditRateModalVisible] = useState(false);

	const editLocation = useCallback(
		(record) => (e) => {
			stopDefaultEvents(e);
			setCurrentEditingRecord(record);
			setEditRateModalVisible(true);
		},
		[]
	);

	const hideEditRateModal = useCallback(() => setEditRateModalVisible(false), []);

	const columns = useMemo(
		() => [
			{
				title: 'Location',
				dataIndex: 'name',
			},
			{
				title: 'Tax Rate',
				dataIndex: 'taxRate',
				render: (taxRate) => {
					return <div>{`${taxRate || 0}%`}</div>;
				},
			},
			{
				render: (_, record) => (
					<div>
						<Button type="ghost" onClick={editLocation(record)}>
							Edit
						</Button>
					</div>
				),
			},
		],
		[editLocation]
	);

	return (
		<>
			<PaginatedReduxTableWithHeader
				targetCollectionName="locationsIndex"
				updateFilters={updateFilters}
				stateSlice={locations}
				clearAndUpdateFilters={clearAndUpdateFilters}
				filterConfig={[]}
				entityCollectionName="locations"
				tableColumns={columns}
				fetchData={locationsRestCrudThunksForSupplier.readLite}
				rightActions={null}
				showHeader
				emptyState={
					<EmptyState
						graphic={
							<img
								alt="No Data"
								style={{ marginBottom: 8 }}
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/box.svg"
							/>
						}
						headline={'No locations found'}
						body={null}
					/>
				}
			/>
			{editRateModalVisible && (
				<TaxRateModal record={currentEditingRecord} onCancel={hideEditRateModal} />
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	locations: state.locations,
});

const mapDispatchToProps = (dispatch) => ({
	updateFilters: (filters, targetCollection) =>
		dispatch(LOCATIONS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(LOCATIONS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(filters, targetCollectionName)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(AccountingTaxRatePage)
);
